__webpack_require__.p = "/newsextension/";